__webpack_require__.p = "/triphalal/";